import { useFieldArray, useFormContext } from "react-hook-form"

import { Button, IconButton } from "components/Button"
import FaIcon from "components/FontAwesomeIcon"
import { Select } from "components/forms/FormElements"

import type { ProductAddonWithImages } from "pages/products/[slug]"

// export type DoorSensorAreas =
//   | "Front door"
//   | "Back door"
//   | "Patio door"
//   | "Utility room door"
//   | "Conservatory door"
//   | "Other"

export const doorSensorAreas = [
  "Front door",
  "Back door",
  "Patio door",
  "Utility room door",
  "Conservatory door",
  "Other"
]

const AddonTemplateDoorSensors: React.FC<{ addon: ProductAddonWithImages }> = ({
  addon
}) => {
  const rhf = useFormContext()
  const { fields, append, remove } = useFieldArray({
    control: rhf.control,
    name: `addons.${addon.id}.title`
  })

  return (
    <>
      <div>
        {fields.map((field, index) => (
          <div
            key={`${field.id}-${addon.id}`}
            className="flex gap-2 items-center w-full"
          >
            <Select
              className="w-full"
              showLabel
              showRequired
              customLabel={`Door sensor ${index + 1}`}
              options={doorSensorAreas.map(area => ({
                value: area,
                label: area
              }))}
              {...rhf.register(`addons.${addon.id}.title.${index}`, {
                required: true
              })}
            />
            {index > 0 && (
              <IconButton
                className="mt-3"
                icon="times"
                onClick={() => {
                  remove(index)
                  // also set the quantity of addons.${addon.id}.quantity to the length of addons.${addon.id}.title - 1
                  rhf.setValue(`addons.${addon.id}.quantity`, fields.length - 1)
                }}
              />
            )}
          </div>
        ))}
      </div>
      <Button
        kind="visual"
        onClick={() => {
          append(
            doorSensorAreas.find(
              option =>
                !rhf.getValues(`addons.${addon.id}`).title.includes(option)
            ) || "Other"
          )
          // also set the quantity of addons.${addon.id}.quantity to the length of addons.${addon.id}.title + 1
          rhf.setValue(`addons.${addon.id}.quantity`, fields.length + 1)
        }}
      >
        <FaIcon icon="plus" className="mr-2" />
        Add additional door sensor
      </Button>
    </>
  )
}

export default AddonTemplateDoorSensors
